'use strict';

module.exports = '3.18.0';
